<template>
  <section class="pa-section pa-section-index-main-field" id="pa_introduction_field">
    <article>
      <p class="title-field"><span class="pa-text">プロローグ</span></p>

      <div class="content-field">
        <div class="hero-top-wrap">
          <p class="hero-text hero-text-medium">塔経市帝（トーキョーシティー）、</p>
          <p class="hero-text hero-text-medium">昭葉原（アキバハラ）。</p>
          <p class="hero-text hero-text-medium">そこは、次元の違う異世界の街。</p>
        </div>

        <p class="pa-line-separator">
          <PaDiaFour class="dia-four" />
        </p>
        
        <div class="hero-text-wrap">
          <p class="hero-text hero-text-medium hero-text-justify-long hero-text-nomt">時空の割れ目（曲世線）が出来易く、</p>
          <p class="hero-text hero-text-middle">異世界と異世界を繋ぐ異世界同士の</p>
          <p class="hero-text hero-text-middle">経由地として機能している。</p>
          <p class="hero-text hero-text-justify-long">なかでも昭葉原は曲世線が出来易く、</p>
          <p class="hero-text hero-text-middle">様々な異世界から、いろいろな</p>
          <p class="hero-text hero-text-middle hero-text-justify-long">「モノ」や「コト」が舞い込んでくる
          <p class="hero-text hero-text-middle">特異な街。</p>
          <p class="hero-text">そんな塔経市帝・昭葉原へ</p>
          <p class="hero-text hero-text-middle">魔法が当たり前に存在する世界から</p>
          <p class="hero-text hero-text-middle">曰く付きの仮面と一人の少女がやってた。</p>
          <p class="hero-text">曰く付きの仮面は</p>
          <p class="hero-text hero-text-middle">仮面舞踏会を司る神の化身。</p>
          <p class="hero-text hero-text-middle">少女の名前はリリカ、</p>
          <p class="hero-text hero-text-middle">不思議な仮面の世話人。</p>

          <p class="pa-line-separator">
            <PaDiaFour class="dia-four" />
          </p>

          <p class="hero-text hero-text-nomt">時を同じくして、</p>
          <p class="hero-text hero-text-middle hero-text-justify-long">塔経市帝の電脳線網に歪みが発生し、</p>
          <p class="hero-text hero-text-middle">別次元のネットワークへと</p>
          <p class="hero-text hero-text-middle">繋がってしまった。</p>
          <p class="hero-text">別次元のネットワークの名前は</p>
          <p class="hero-text hero-text-middle hero-text-justify-long-x">ＷＷＷ（ワールド・ワイド・ウェブ）。</p>
          <p class="hero-text hero-text-middle">異世界地球に在りし電脳線網。</p>
          <p class="hero-text">ＷＷＷの特定のドメインと繋がる</p>
          <p class="hero-text hero-text-middle">曲世線が持続的に発生し、</p>
          <p class="hero-text hero-text-middle">塔経市帝当局は頭を抱えていた。</p>
          <p class="hero-text">異世界との面倒事を処理するための</p>
          <p class="hero-text hero-text-middle">行政機関、２４区番外地管理局は</p>
          <p class="hero-text hero-text-middle">仮面と少女を保護。</p>

          <div class="three-line">
            <p class="hero-text hero-text-short hero-text-left">「仮面の存りし所、</p>
            <p class="hero-text hero-text-short hero-text-middle">人々の身分を明かさず交流し、</p>
            <p class="hero-text hero-text-short hero-text-middle  hero-text-right">真の親睦を深め給え」</p>
          </div>

          <p class="hero-text">という仮面のオキテに従うため、</p>
          <p class="hero-text hero-text-middle">２４区番外地管理局は異世界地球と</p>
          <p class="hero-text hero-text-middle">塔経市帝を繋ぐ仮面舞踏会を</p>
          <p class="hero-text hero-text-middle">開くことを決定した。</p>

          <p class="pa-line-separator">
            <PaDiaFour class="dia-four" />
          </p>

          <p class="hero-text hero-text-nomt">次元を超えた仮面舞踏会へ、</p>
          <p class="hero-text hero-text-middle  hero-text-down hero-text-down-final">どうそお越しください。</p>

          <p class="button-field">
            <button
             class="button pa-button pa-button-large"
             @click.prevent="handleClickRegistration"
            >新規接続申請へ</button>
          </p>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import PaDiaFour from '@/components/FrontParts/PaIndexMainField/Images/dia-four.svg?inlineN'

export default {
  components : {
    PaDiaFour
  },
  methods : {
    startAnimation(){
      var introTitle       = document.querySelector('#pa_introduction_field p.title-field span.pa-text');
      var heroWrap         = document.querySelector('#pa_introduction_field div.hero-top-wrap');
      var heroTextWrap     = document.querySelector('#pa_introduction_field div.hero-text-wrap');
      var contentSeparator = document.querySelector('p.pa-line-separator');

      // すでに一度スクロール済みだった場合は一旦消す
      if(introTitle.classList.contains('start-fade-blink')){
        introTitle.classList.remove('start-fade-blink');
      }

      // コンテンツを全て隠す
      var topPlist = heroWrap.querySelectorAll('p.hero-text');
      for(var i = 0; i < topPlist.length; ++i){
        topPlist[i].classList.add('hide');
      }
      heroTextWrap.classList.add('hide');
      contentSeparator.classList.add('hide');

      this.$scrollTo('#pa_introduction_field', 700, {
        onDone: function() {
          var animDelay = function(el, querySelector, delay, cb){
            if(cb === undefined) cb = function(){};

            setTimeout(function(){
              //テキストをアニメーションする
              if(querySelector !== null){
                el.querySelector(querySelector).classList.remove('hide');
                el.querySelector(querySelector).classList.add('fade-anim');
              }else{
                el.classList.remove('hide');
                el.classList.add('fade-anim');
              }
              cb();
            }, delay);
          };

          setTimeout(function(){
            introTitle.classList.add('start-fade-blink');

            animDelay(heroWrap, 'p:nth-child(1)', 1000, function(){
              animDelay(heroWrap, 'p:nth-child(2)', 1300, function(){
                animDelay(heroWrap, 'p:nth-child(3)', 1800, function(){
                  animDelay(contentSeparator, null, 1500);

                  animDelay(heroTextWrap, null, 1500, function(){
                    heroWrap.querySelector('p:nth-child(1)').classList.remove('fade-anim');
                    heroWrap.querySelector('p:nth-child(2)').classList.remove('fade-anim');
                    heroWrap.querySelector('p:nth-child(3)').classList.remove('fade-anim');
                    setTimeout(function(){
                      heroTextWrap.classList.remove('fade-anim');
                    }, 3000);
                  });
                });
              });
            });

          }, 50);
        }
      });
    },

    handleClickRegistration(){
      this.$router.push({
        name    : 'registration.notice',
      });
      // const newUrlQuery = Object.assign({}, this.$route.query);

      // newUrlQuery['is_open_registration_test_modal'] = 'yes';

      // this.$router.push({
      //   name    : this.$route.name,
      //   params  : this.$route.params,
      //   query   : newUrlQuery
      // });
    }
  },
  
  mounted(){
    this.$parent.$on('startMainFieldAnimation', () => {
      this.startAnimation();
    });
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

@keyframes textFaceChangeColor
{
  0%  {
    color:#876E58;
  }
  100% {
    color:#D1D1D1;
  }
}

@keyframes fadeInScaleM
{
  0%  {
    transform:scale(.95);
    opacity:0;
  }
  100% {
    transform:scale(1);
    opacity:1;
  }
}

@keyframes faseInScaleS
{
  0%  {
    transform:scale(.99);
    opacity:0;
  }
  100% {
    transform:scale(1);
    opacity:1;
  }
}

.pa-section{
  &-index-main-field{
    margin-bottom:1.5rem;

    @include from($tablet) {
      max-width: 840px;
      margin:.75rem auto 0;
    }

    article{
      svg.dia-four{
        .cls-1{
          fill: #d1baa0;
        }

        .cls-2{
          fill: #aa8f75;
        }

        .cls-3{
          fill: #aa8f75;
          stroke: #dcceb4;
          stroke-miterlimit: 10;
          stroke-width: 4px;
        }
      }
      .title-field{
        font-weight: bold;
        line-height: 3.5rem;
        font-size: 2rem;
        text-align: center;

        background-color: $content-title-background;
        color: $content-title-text;
        background-image: url('./Images/intro-tile2.svg');
        background-size: contain;

        @include from($tablet) {
          font-size:2.2rem;
          line-height: 3.7rem;
        }

        .start-fade-blink{
          animation: textFaceChangeColor 1s normal ease-in-out;
          color: $content-title-text-blink;
        }
      }

      .content-field{
        border:6px solid $content-border;
        background-color:$content-background;

        .hide{
          opacity: 0;
        }

        .fade-anim{
          animation: fadeInScaleM 1.5s normal ease-in-out;
        }

        div.fade-anim{
          animation: faseInScaleS 1.5s normal ease-in-out;
        }

        p{
          text-align: center;
          font-size: 1.4rem;
          line-height: 2rem;
          margin-top:.6rem;

          @include from($tablet) {
            font-size: 1.6rem;
            line-height: 2.1rem;
          }
        }

        p.hero-text{
          margin-top:3rem;

          &-medium{
            margin-top:1.8rem;
          }

          &-short{
            font-size:1.3rem;
          }

          &-down{
            margin-top:1rem;
            margin-bottom:3rem;

            &-final{
              margin-bottom: 1.2rem;
            }
          }

          &-nomt{
            margin-top:0;
          }

          &-isolate{
            margin-bottom:3rem;
          }

          &-justify-long{
            font-size:1.3rem;

            @include from($tablet) {
              font-size:1.6rem;
            }
          }

          &-justify-long-x{
            font-size: 1.26rem;

            @include from($tablet) {
              font-size:1.6rem;
            }
          }

          &-middle{
            margin-top:.3rem;
          }

          &-left{
            text-align: left;
          }

          &-right{
            text-align: right;
          }
        }

        div.three-line{
          @include from($tablet) {
            max-width:65%;
            margin:0 auto;

            p.hero-text{
              font-size:1.6rem;
              line-height: 2.2rem;
            }
          }
        }

        p.pa-line-separator{
          margin:1.65rem auto 1.6rem;
          max-width:50vw;
          @include from($tablet) {
            max-width:220px;
          }
        }

        p.button-field{
          margin-bottom:2.3rem;
        }
      }
    }

    .pa-button{
      background-color: #966e53;
      border:5px solid #8c7460;
      border-color: #8c7460;
      color:#e5e5e5;
      height:inherit;

      &-large{
        border-radius: 20px;
        width:70%;
        font-size:1.2rem;
        line-height: 1.4rem;
        letter-spacing: 4px;
        max-width:250px;
      }

      .pa-line{
        display: block;
      }

      .is-hovered, :hover{
        border-color: #856448;
        color:#DCDCDC;
      }

      .is-focused, :focus{
        border-color: #856448;
        color:#DCDCDC;
        &:not(:active){
          box-shadow:none;
        }

        .is-active, :active{
          border-color: #856448;
          color:#DCDCDC;
        }
      }
    }
  }
}
</style>